import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  headersBase,
  headersExternal,
  headersNoBearer,
  headersNoStudio,
  headersType,
} from "../../../utils/constants/headersForApi";

export const tenatApi = createApi({
  reducerPath: "tenatApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getTenant: builder.query({
      query: (external = false) => ({
        url: "/Tenant",
        method: "GET",
        headers: headersExternal(external),
      }),
    }),
    getStudioTenantId: builder.query({
      query: ({ query, tenantId }) => ({
        url: `/studios/?query=${query}&tenantId=${tenantId}`,
        method: "GET",
        headers: headersBase(),
      }),
    }),
    getStudioExternalTenantId: builder.query({
      query: ({ query, tenantId }) => ({
        url: `Tenant/studios/${tenantId}?query=${query}`,
        method: "GET",
        headers: headersNoBearer(),
      }),
    }),
    checkTenant: builder.query({
      query: ({ tenantId = "", userId }) => ({
        url: `/User/tenantagreement/check?userId=${userId}&tenantId=${tenantId}`,
        method: "GET",
        headers: headersBase(),
      }),
    }),
    consentTerms: builder.mutation({
      query: (body) => {
        return {
          url: "/User/tenantagreement/assign",
          method: "POST",
          headers: headersType(),
          body: body,
        };
      },
    }),
    getTenantServices: builder.query({
      query: ({ tenantId }) => ({
        url: `/Tenant/services/${tenantId}`,
        method: "GET",
        headers: headersNoStudio(),
      }),
    }),
  }),
});

export const {
  useGetTenantQuery,
  useGetStudioTenantIdQuery,
  useGetStudioExternalTenantIdQuery,
  useCheckTenantQuery,
  useConsentTermsMutation,
  useGetTenantServicesQuery,
} = tenatApi;
